




//import CategoryTiles from '../common/CategoryTiles';
import React, { useMemo, useState, useEffect } from 'react';
import {
  FiSearch,
  FiX,
  FiPackage,
  FiPhoneCall,
  FiArrowRight,
  FiZap,
  FiEye,
} from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import Reveal from '../common/Reveal';
import { categories, slugify } from '../data/categories';
import heroBg from '../assest/hero/product  heroimage.png';

const totalProducts = categories.reduce((sum, c) => sum + c.items.length, 0);
const ALL = 'All Products';

// Sparkle icon jo reference banner me tha
const Sparkle = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} width="18" height="18">
    <path d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z" fill="currentColor" />
  </svg>
);

export default function Products() {
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(ALL);
  const location = useLocation();

  // When arriving via a link like /products#pin-disc-insulators (e.g. from the
  // header dropdown), select that category automatically and scroll to the top
  // of the catalogue section.
  useEffect(() => {
    const hash = location.hash?.replace('#', '');
    if (!hash) return;
    const match = categories.find((c) => slugify(c.title) === hash);
    if (!match) return;
    setSelected(match.title);
    const timer = setTimeout(() => {
      const el = document.getElementById('catalogue');
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 80);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.hash]);

  // Products shown in the main panel: filtered by the active category, and
  // further narrowed by the search query if one is typed.
  const visibleItems = useMemo(() => {
    const q = query.trim().toLowerCase();
    const base =
      selected === ALL
        ? categories.flatMap((cat) => cat.items.map((item, idx) => ({ item, cat, idx })))
        : (() => {
            const cat = categories.find((c) => c.title === selected);
            return cat ? cat.items.map((item, idx) => ({ item, cat, idx })) : [];
          })();

    if (!q) return base;
    return base.filter(
      ({ item, cat }) => item.name.toLowerCase().includes(q) || cat.title.toLowerCase().includes(q)
    );
  }, [selected, query]);

  return (
    <div className="bg-white">
      {/* ---------------- HERO ---------------- */}
    {/* ---------------- HERO ---------------- */}
<section className="relative h-screen w-full overflow-hidden bg-navy">
  <img
    src={heroBg}
    alt=""
    className="absolute inset-0 h-full w-full object-cover"
    style={{ objectPosition: 'center 70%' }}
  />
  {/* dark gradient so left-side text stays readable over the product image */}
  <div className="absolute inset-0 bg-gradient-to-r from-navy/90 via-navy/40 to-transparent" />
  {/* LEFT CONTENT — badge, heading, description, buttons */}
  <div className="absolute inset-0 flex items-center">
    <div className="mx-auto w-full max-w-7xl px-6 sm:px-10 lg:px-14">
      <div className="max-w-xl">
        {/* Badge */}
        <span className="inline-flex items-center gap-2 rounded-full border border-brand-orange/40 bg-brand-orange/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
          <Sparkle className="text-brand-orange" /> Our Products
        </span>
        {/* Heading */}
        <h1 className="mt-5 text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl">
          Powering Every Connection with{' '}
          <span className="hero-shimmer text-brand-orange">Industry-Leading Solutions</span>
        </h1>
        {/* Description */}
        <p className="mt-5 max-w-md text-sm leading-relaxed text-white/70 sm:text-base">
          Explore our comprehensive range of transformers, conductors, insulators,
          switchgear, cables, and power distribution equipment—engineered to
          deliver exceptional performance, reliability, and long-lasting
          durability for every electrical infrastructure project.
        </p>
        {/* Buttons */}
        <div className="mt-8 flex flex-wrap items-center gap-4">
          <a
            href="#catalogue"
            className="inline-flex items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-brand-orangedark"
          >
            View Products <FiArrowRight />
          </a>
          <a
            href="/catalogue.pdf"
            download
            className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:border-white"
          >
            Download Catalogue
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* ---------------- PRODUCT NAME MARQUEE (below hero) ---------------- */}
     

      {/* ---------------- CATALOGUE: sidebar + product grid ---------------- */}
      <section id="catalogue" className="scroll-mt-24 mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="lg:flex lg:items-start lg:gap-10">
          {/* ---- Sidebar: category list ---- */}
          <aside className="mb-8 lg:mb-0 lg:w-72 lg:shrink-0">
            <div className="lg:sticky lg:top-24">
              <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Categories</p>
              <nav className="flex gap-2 overflow-x-auto pb-2 lg:flex-col lg:overflow-visible lg:pb-0">
                <button
                  onClick={() => setSelected(ALL)}
                  className={`whitespace-nowrap rounded-xl px-4 py-3 text-left text-sm font-bold transition lg:whitespace-normal ${
                    selected === ALL ? 'bg-navy text-white' : 'text-navy hover:bg-slate-50'
                  }`}
                >
                  All Products ({totalProducts})
                </button>
                {categories.map((cat) => (
                  <button
                    key={cat.title}
                    onClick={() => setSelected(cat.title)}
                    className={`whitespace-nowrap rounded-xl px-4 py-3 text-left text-sm font-bold transition lg:whitespace-normal ${
                      selected === cat.title ? 'bg-navy text-white' : 'text-navy hover:bg-slate-50'
                    }`}
                  >
                    {cat.title} ({cat.items.length})
                  </button>
                ))}
              </nav>
            </div>
          </aside>

          {/* ---- Main: search + product grid ---- */}
          <div className="min-w-0 flex-1">
            {/* Search */}
            <div className="relative max-w-lg">
              <FiSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search products..."
                className="w-full rounded-full border border-slate-200 bg-white py-3.5 pl-11 pr-11 text-sm font-medium text-navy shadow-sm outline-none placeholder:text-slate-400 focus:border-brand-orange focus:ring-2 focus:ring-brand-orange/20"
              />
              {query && (
                <button
                  onClick={() => setQuery('')}
                  aria-label="Clear search"
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 transition hover:text-brand-orange"
                >
                  <FiX size={18} />
                </button>
              )}
            </div>

            <p className="mt-5 text-sm text-slate-500">
              Showing <span className="font-bold text-navy">{visibleItems.length}</span> product
              {visibleItems.length !== 1 ? 's' : ''}
            </p>

            {visibleItems.length === 0 ? (
              <div className="mt-8 flex flex-col items-center justify-center rounded-3xl border border-dashed border-slate-200 py-20 text-center">
                <FiPackage size={36} className="text-slate-300" />
                <p className="mt-4 font-semibold text-navy">No products match &ldquo;{query}&rdquo;</p>
                <p className="mt-1 text-sm text-slate-500">Try a different keyword, or get in touch — we likely stock it.</p>
                <button
                  onClick={() => setQuery('')}
                  className="mt-5 rounded-full bg-brand-orange px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-orangedark"
                >
                  Clear search
                </button>
              </div>
            ) : (
              <div className="mt-6 grid grid-cols-2 gap-5 sm:grid-cols-3">
                {visibleItems.map(({ item, cat, idx }, i) => (
                  <Reveal key={cat.title + item.name + idx} delay={(i % 6) * 60}>
                    <div className="group relative overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm transition duration-300 hover:-translate-y-1.5 hover:border-brand-orange/30 hover:shadow-xl hover:shadow-navy-900/5">
                      <Link
                        to={`/products/${slugify(cat.title)}/${idx}`}
                        className="relative flex aspect-square items-center justify-center overflow-hidden bg-slate-50/70 p-5"
                      >
                        {item.img ? (
                          <img
                            src={item.img}
                            alt={item.name}
                            className="h-full w-full object-contain object-center transition duration-500 group-hover:scale-110"
                            loading="lazy"
                          />
                        ) : (
                          <div className="flex flex-col items-center gap-2 text-slate-300">
                            <FiZap size={32} />
                            <span className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">
                              Photo coming soon
                            </span>
                          </div>
                        )}

                        {/* Hover overlay with View button */}
                        <div className="absolute inset-0 flex items-center justify-center bg-navy/0 opacity-0 transition-all duration-300 group-hover:bg-navy/55 group-hover:opacity-100">
                          <span className="inline-flex translate-y-2 items-center gap-1.5 rounded-full bg-white px-4 py-2 text-xs font-bold text-navy shadow-lg transition-transform duration-300 group-hover:translate-y-0">
                            <FiEye size={14} /> View Details
                          </span>
                        </div>
                      </Link>
                      <div className="border-t border-slate-100 px-3.5 py-3.5">
                        <p className="text-[10px] font-bold uppercase tracking-wide text-brand-orange">{cat.title}</p>
                        <p className="mt-1 line-clamp-2 text-sm font-bold leading-snug text-navy">{item.name}</p>
                        <Link
                          to={`/products/${slugify(cat.title)}/${idx}`}
                          className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-brand-orange transition hover:gap-1.5"
                        >
                          View Specifications <FiArrowRight size={12} />
                        </Link>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ---------------- CTA ---------------- */}
      <section className="px-4 pb-16 sm:px-6 lg:px-8">
        <Reveal className="mx-auto flex max-w-5xl flex-col items-center gap-4 overflow-hidden rounded-3xl bg-navy px-8 py-12 text-center text-white sm:px-16">
          <FiPackage size={28} className="text-brand-orange" />
          <h2 className="text-2xl font-extrabold sm:text-3xl">Can&rsquo;t find what you&rsquo;re looking for?</h2>
          <p className="max-w-xl text-white/70">
            Our catalogue keeps growing — if you have a spec sheet or a BOQ, send it over and we&rsquo;ll confirm
            availability and pricing.
          </p>
          <div className="mt-2 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-brand-orangedark"
            >
              <FiPhoneCall /> Talk to Us
            </Link>
            <a
              href="tel:+91 9958260035"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:border-white"
            >
              +91 9958260035 <FiArrowRight />
            </a>
          </div>
        </Reveal>
      </section>
    </div>
  );
}